module.exports = __webpack_public_path__ + "static/media/align-left.94e1edc5.svg";